import { BooleanInputDefinition } from '../../../../types';

// boolean input validation
export default (input: BooleanInputDefinition, errors: string[]) => {
  const { trueLabel = 'Yes', falseLabel = 'No' } = input;
  if (trueLabel === falseLabel) {
    errors.push(`True Label and False label are the same: "${trueLabel}"`);
  }
};
